import { Box, Collapse, VStack } from '@chakra-ui/react';
import { memo } from 'react';
import LabelWithValueMobilePage from '../../../../../components/Mobile/labelWithValue';
import { IVacanciesProps } from '../../../../../services/hooks/SelectiveProcess/Types';

interface IOwnProps {
  isOpen: boolean;
  data: IVacanciesProps;
}

const MoreDetailVacancyMobilePage: React.FC<IOwnProps> = ({ isOpen, data }) => {
  return (
    <Collapse in={isOpen} animateOpacity>
      <Box mt={4}>
        <VStack align="start" fontSize="x-small" spacing={2}>
          {data.level && <LabelWithValueMobilePage label="Escolaridade" value={data.level.name} />}
          <LabelWithValueMobilePage label="Valor da inscrição" value={`R$ ${data.value}`} />
          <LabelWithValueMobilePage label="Carga horária" value={data.workload} />
          {data.has_cr && (
            <LabelWithValueMobilePage
              label="Quantidade de cadastro de reserva"
              value={data.number_of_cr_vacancies.toString()}
            />
          )}
          {data.has_pcd && (
            <LabelWithValueMobilePage
              label="Quantidade de vagas para cotas para Pessoa com deficiência (PCD)"
              value={data.number_of_pcd_vacancies.toString()}
            />
          )}
          {data.has_black_or_brown && (
            <LabelWithValueMobilePage
              label="Quantidade de vagas para cotas raciais"
              value={data.number_of_black_or_brown_vacancies.toString()}
            />
          )}
          {data.details && <LabelWithValueMobilePage label="Detalhes" value={data.details} acceptTag />}
          {/* <Text pr={4} pb={1} mb={2} fontWeight="bold" borderBottom="1px solid" borderColor="gray.200">
            Resposta da análise de isenção
          </Text> */}
          {/* <Stack gap={0.5} ml={2}>
            <LabelWithValueMobilePage label="Situação" value={dataToExemption?.status} />
            {dataToExemption?.justification && (
              <LabelWithValueMobilePage
                label="Justificativa da análise"
                value={dataToExemption?.justification}
                acceptTag
              />
            )}
          </Stack> */}
        </VStack>
      </Box>
    </Collapse>
  );
};

export default memo(MoreDetailVacancyMobilePage);
